var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"selectable-checkpoint-line",class:{ 'is-disabled': _setup.isDisabled }},[_c(_setup.MinimalisticReadinessLevel,{attrs:{"level":_vm.level,"disabled":_setup.isDisabled}}),_c('span',{staticClass:"selectable-checkpoint-line__title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }